// snake_case wire shapes from oiq-backend-service KB API, plus the camelCase shapes orioniq-be exposes to its chat clients.
/** The default account memory doc — auto-seeded for empty accounts and protected from deletion (FE + BE). */
export const PROTECTED_ACCOUNT_DOC_NAME = 'ACCOUNT.md';
/**
 * Whether a document is the protected default, matched case-insensitively (and trimmed) so the KB
 * backend's case-sensitive keys can't smuggle in a deletable variant like `account.md`.
 */
export const isProtectedAccountDoc = (documentName) => documentName.trim().toLowerCase() === PROTECTED_ACCOUNT_DOC_NAME.toLowerCase();
//# sourceMappingURL=oiq-account-docs.types.js.map